/**
 * The onboarding screen a data-upload file belongs to (`assignedTo`), by its step title. Shared
 * by the three upload screens (Add Teachers, Students, Teacher Allocation) so "this is the X
 * list" names the step the same way everywhere.
 */
export const STEP_TITLE_KEYS: Record<string, string> = {
  teachers: 'ONBOARDING_WIZARD.STEP4_MANUAL.TABS.TEACHERS',
  students: 'ONBOARDING_WIZARD.STEP4_MANUAL.TABS.STUDENTS',
  allocation: 'ONBOARDING_WIZARD.STEP4_MANUAL.TABS.LESSON_PLANNING',
}
